import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { tap } from 'rxjs';
import { DeploymentService } from 'src/app/core/services/deployment.service';

@Component({
  selector: 'app-update-credentials',
  templateUrl: './update-credentials.component.html',
  styleUrls: ['./update-credentials.component.scss']
})
export class UpdateCredentialsComponent implements OnInit {

  credentialsForm: UntypedFormGroup = new UntypedFormGroup({
    username: new UntypedFormControl("", [Validators.required, Validators.pattern(/(.*[a-z]){3}/i)]),
    password: new UntypedFormControl("", [Validators.required, Validators.pattern(/(.*[a-z]){3}/i)])
  });
  depName = this.data.depName;

  constructor(
    private _deploymentService: DeploymentService,
    public dialogRef: MatDialogRef<UpdateCredentialsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { depName: string },
    private _spinner: NgxSpinnerService,
    private _snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this._spinner.show("updateCredential");
    this.getAdminUsernameOfDeployment();
  }

  getAdminUsernameOfDeployment(){
    this._deploymentService.getAdminUsernameForDeployment(this.depName)
    .pipe(tap(d => this._spinner.hide("updateCredential")))
    .subscribe({
      next: (data: any) => {
        this.credentialsForm.controls["username"].setValue(data.adminUsername);
        // this.credentialsForm.updateValueAndValidity();
      }
    })
  }

  onSubmit(){
    this._spinner.show("updateCredential");
    let credObj = {
      username: this.credentialsForm.value.username,
      password: this.credentialsForm.value.password
    }
    this._deploymentService.updateDeploymentAdminCredentials(this.depName, credObj)
    .pipe(tap(d => this._spinner.hide("updateCredential")))
    .subscribe({
      next: (data: any) => {
        this._snackBar.open(data.actionMessage, "Ok", {
          duration: 7000
        })
        this.onCancel();
      },
      error: (err) => {
        this._snackBar.open(err.error.actionMessage, "Ok", {
          duration: 7000
        });
        this.onCancel();
      }
    })
  }

  onCancel(){
    this.dialogRef.close();
  }

}
